module.exports = __webpack_public_path__ + "static/media/gammel.fa5c6694.m4a";